<template>
    <div id="orderInvoice">
        <div style="width: 800px; min-width: 800px; height: auto; margin:  0 auto;">
            <div class="invoice_box">
                <table>
                    <tr>
                        <td style="width: 100%;">
                            <div class="main_header">
                                <table class="mb_0">
                                    <tr>
                                        <td style="width: 100%; ">
                                            <div>
                                                <h2 style="font-size: 23px; line-height: 28px; padding: 33px 0px 5px;">
                                                    <div v-html="question.title ? question.title : ''"></div>
                                                </h2>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100% ">
                                            <div v-html="question.commentary ? question.commentary : ''"></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            question: [],
        }
    },
    created() {
        document.querySelector('body').style.width = 100 + '%'
        document.querySelector('body').style.minWidth = 100 + '%'
        this.loadData();
    },
    mounted(){
        setTimeout(() => {
            document.title = 'Question Print'
            window.print();
            window.close();
        }, 100);
    },
    methods: {
        loadData() {
            let questionId = JSON.parse(this.$route.params.question_id)
            this.axios.get('/question-print', {params: {question_id: questionId}}).then((response) => this.question = response.data)
        }
    }
}
</script>
<style scoped>
    @page {
        margin: 30px;
    }

    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    .clearfix {
        clear: both;
    }

    body {
        margin: 0;
    }

    h1,
    h2,
    p {
        margin: 0;
    }

    p {
        font-size: 12px;
        line-height: 17px;
        font-weight: 500;
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    li {
        font-size: 12px;
        line-height: 18px;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 10px;
    }
    .mb_0 {
        margin-bottom: 0;
    }
    .mb_5 {
        margin-bottom: 5px;
    }
    .mb_10 {
        margin-bottom: 10px;
    }
    .table_border_none th,
    .table_border_none td{
        border: none!important;
    }
    .is_border_bottom{
        border: none!important;
        border-bottom: 1px solid !important;
    }
    .border_bottom_none{
        border: none!important;
    }
    .border_none{
        border: none!important;
    }
    .invoice_box {
        max-width: 800px;
        margin: auto;
        padding: 0px 30px;
        border: 1px solid #eee;
        -webkit-box-shadow: 1px -2px 40px -1px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 1px -2px 40px -1px rgba(0, 0, 0, 0.75);
        box-shadow: 1px -2px 40px -1px rgba(0, 0, 0, 0.75);
        font-size: 12px;
        line-height: 24px;
        font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
        color: #000;
        background: #fff;
        line-height: 17px;
    }
    @media print {
        @page {
            margin-top: 10px;
            margin-bottom: 0;
        }
    }
</style>